module.exports = __webpack_public_path__ + "static/apollo-caf86168ad2c8d73cb68d4984ad58863.png";